import React from 'react';
import styled from 'styled-components';

// Components
import RadioInputComponent from '../../../ui/advisory-flow/components/shared-components/RadioInputComponent';

// Types
import IconSelector from '../../../../../../common/src/components/IconSelector';
import TextError from '../../../ui/advisory-flow/components/shared-components/TextError';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';

interface Props {
  question: FlowsQuestion;
}

const IconSelectInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({
    question,
  });

  const options = useQuestionEnum(question);

  const handleOnSelected = (enumKey: string) => {
    if (enumKey === value) onBlur({ name: question.id, value: undefined });
    else onBlur({ name: question.id, value: enumKey });
  };

  return (
    <>
      <TextError error={error?.message} />
      <Wrapper data-test-id="ProdFac_IconSelectInputComponent">
        {options.map(({ label, value: _value }) => (
          <RadioInputComponent
            key={label + _value}
            Icon={<IconSelector type={_value as string} />}
            title={label}
            isSelected={value === _value}
            onClick={() => handleOnSelected(_value as string)}
          />
        ))}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  > div {
    margin-bottom: 0.8rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export default IconSelectInputComponent;
